import React from "react";
import { Button } from "antd";
import AudioPlayer from "./AudioPlayer/AudioPlayer";
import customButtonStyle from "../components/Button";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";

export function AudioPlaybackBar(isDisabled: () => boolean, loading: boolean, GenerateSpeech: () => void, btnText: string, audioSrc: string, recordingType?: string, prohibitPlay?: boolean, title?: string,) {
    const isTabs = useSelector((state: any) => state?.library?.isTabs)

    return <AudioPlayerDiv>
        <div style={{ flex: 1, minWidth: 0 }}>
            <AudioPlayer isTabs={isTabs} audioSrc={audioSrc} title={title} style={{ marginLeft: "0px", width: '100%' }} recordingType={recordingType} prohibitPlay={prohibitPlay}></AudioPlayer>
        </div>
		{recordingType === 'noFlowType' || !recordingType ? <div>
            <MyButton
                disabled={isDisabled()}
                style={{ ...customButtonStyle, background: (loading || isDisabled()) ? "#FF9E6F" : "#FF671D" }}
                onClick={GenerateSpeech}>
                {/* <span className='icon loading' hidden={!loading}></span> */}
                {btnText}
            </MyButton>
		</div> : null}

    </AudioPlayerDiv>
}

const MyButton = styled(Button)`
   width: 160px ;
   height: 50px !important;
   display: flex;
   align-items: center;
   justify-content: center;
    `
const AudioPlayerDiv = styled.div`
   display: flex;
   width: 100%;
   align-items: center;
   gap: 20px;
  //   margin-top: 12px;
  `

